import { ImportStatus } from '@synergy/models';

export const isImportDeletable = (importStatus: ImportStatus) => {
    switch (importStatus) {
        case ImportStatus.ReadyToPublish:
            return true;
        case ImportStatus.Calculating:
            return true;
        case ImportStatus.Created:
            return true;
        case ImportStatus.Receiving:
            return true;
        default:
            return false;
    }
};
